module.exports = __webpack_public_path__ + "static/media/co.3a37de80.png";